export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover a unidade <b>${this.currentEntity.unit.number}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/unit/index/resources/computed.js